// Domain and Route Configuration
export const DOMAIN_NAME = 'kpiGoal';
export const GOAL_ROUTE_ID = 33;

// API Endpoints
export const API_ENDPOINTS = {
    GET_ALL: '/kpi/goal/get/all',
    GET_BY_ID: '/kpi/goal/get',
    CREATE: '/kpi/goal/create',
    UPDATE: '/kpi/goal/update',
    DELETE: '/kpi/goal/delete',
    GET_DEPARTMENTS: '/department/get/all'
};

// Table Column Configuration
export const TABLE_COLUMNS = [
    { id: 'name', label: 'Name', sortable: true, minWidth: 200 },
    { id: 'description', label: 'Description', sortable: false, minWidth: 300 },
    { id: 'complexity', label: 'Complexity', sortable: true, minWidth: 120 },
    { id: 'department', label: 'Department', sortable: true, minWidth: 150 },
    { id: 'updatedBy', label: 'Updated By', sortable: false, minWidth: 180 },
    { id: 'updatedAt', label: 'Updated At', sortable: true, minWidth: 150 },
    { id: 'actions', label: 'Actions', sortable: false, minWidth: 120, align: 'center' }
];

// Complexity Options with new levels
export const COMPLEXITY_OPTIONS = [
    { value: '', label: 'All Complexity' },
    { value: 'lowest', label: 'Lowest', description: 'Very simple/trivial tasks' },
    { value: 'low', label: 'Low', description: 'Basic tasks' },
    { value: 'medium', label: 'Medium', description: 'Standard work' },
    { value: 'high', label: 'High', description: 'Complex challenges' },
    { value: 'highest', label: 'Highest', description: 'Expert-level work' }
];

// Complexity level details for display
export const COMPLEXITY_DETAILS = {
    lowest: {
        label: 'Lowest',
        color: '#9e9e9e',
        description: 'Very simple/trivial tasks',
        examples: 'Fix typos, update config values, simple text changes'
    },
    low: {
        label: 'Low',
        color: '#4caf50',
        description: 'Basic tasks',
        examples: 'Simple CRUD, basic validation, unit tests'
    },
    medium: {
        label: 'Medium',
        color: '#2196f3',
        description: 'Standard work',
        examples: 'Feature implementation, API endpoints, refactoring'
    },
    high: {
        label: 'High',
        color: '#ff9800',
        description: 'Complex challenges',
        examples: 'System architecture, security, critical bugs'
    },
    highest: {
        label: 'Highest',
        color: '#f44336',
        description: 'Expert-level work',
        examples: 'Core infrastructure, disaster recovery, scalability redesign'
    }
};

// Pagination Configuration
export const ROWS_PER_PAGE_OPTIONS = [10, 20, 50, 100];
export const DEFAULT_PAGE_SIZE = 10;

// Sort Options
export const SORT_BY_OPTIONS = [
    { value: 'updatedAt', label: 'Updated At' },
    { value: 'name', label: 'Name' },
    { value: 'complexity', label: 'Complexity' },
    { value: 'createdAt', label: 'Created At' }
];

// Department Filter Options (will be populated from API)
export const DEPARTMENT_FILTER_ALL = { value: '', label: 'All Departments' };

// Error message extraction utility
export const getErrorMessage = (error, defaultMessage) => {
    // Prioritize API response message if it's a string
    if (error?.response?.data?.message && typeof error.response.data.message === 'string') {
        return error.response.data.message;
    }
    // Fall back to error message
    if (error?.message) {
        return error.message;
    }
    // Use default message
    return defaultMessage;
};
